import { IESignatureEnvelopeParams } from "models/IESignature";

export const BlankESignatureEnvelopeParams: IESignatureEnvelopeParams = {
    emailSubject: "",
    emailBody: "",
    senderEmail: "",
    senderName: "",
    signerEmail: "",
    signerName: "",
    ccSender: true,
    reportID: "",
}